import { useTranslation } from 'react-i18next'
import Header from '@/components/layout/header'
import Footer from '@/components/layout/footer'
import ManifestoHero from './hero'
import Thesis from './thesis'
import Briefings from './briefings'
import ManifestoCta from './cta'
import Seo from '@/components/seo/seo'
import { breadcrumbSchema } from '@/components/seo/json-ld'
import { resolveLang } from '@/lib/site'

export default function Manifesto() {
  const { t, i18n } = useTranslation()
  const lang = resolveLang(i18n.resolvedLanguage)

  return (
    <>
      <Seo
        title={t('seo.manifesto.title') as string}
        description={t('seo.manifesto.description') as string}
        path="/manifesto"
        jsonLd={breadcrumbSchema(lang, [
          { name: 'Bravic', path: '/' },
          { name: t('seo.manifesto.title') as string, path: '/manifesto' },
        ])}
      />
      <Header />
      <main className="relative pt-20 md:pt-28 lg:pt-32 pb-12 md:pb-24 overflow-hidden bg-[radial-gradient(circle_at_20%_30%,rgba(0,166,147,0.05)_0%,transparent_50%),radial-gradient(circle_at_80%_70%,rgba(91,218,198,0.03)_0%,transparent_50%)]">
        <ManifestoHero />
        <Thesis />
        <Briefings />
        <ManifestoCta />
      </main>
      <Footer />
    </>
  )
}
